import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {GetWidgetConfig} from './Vendors/SizerAppAPI';
import setI18n from './i18n';
setI18n();
let widgetConfig = GetWidgetConfig();
let sizerTarget = widgetConfig.rootTag;

if (widgetConfig.topmost === 'true'){
  let sizerRoot = document.createElement("div");
  sizerRoot.setAttribute('id', 'sizerRoot');
  document.body.appendChild(sizerRoot);
  sizerTarget = document.getElementById('sizerRoot');
}

ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    sizerTarget
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
